import { NavLink } from "react-router-dom";
import {
  LayoutDashboard,
  Package,
  ShoppingBag,
  Users,
  LineChart,
  UsersRound,
  Zap,
  Plug,
  Headphones,
  HelpCircle,
  Settings,
  Search,
  Tags,
  ClipboardList,
  Globe,
  Warehouse,
  Building2,
  DollarSign,
  Tag,
  Ticket,
  Truck,
  ShoppingCart,
  PlaneTakeoff,
} from "lucide-react";
import SidebarUserMenu from "./SideBarUserCard";
import { useState } from "react";
import { ChevronDown } from "lucide-react";

const linkBase =
  "flex items-center gap-3 rounded-xl px-3 py-2 text-sm transition";
const linkClass = ({ isActive }) =>
  `${linkBase} ${
    isActive ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-100"
  }`;

function SectionLabel({ children }) {
  return (
    <div className="mt-6 px-2 text-[11px] font-semibold tracking-wide text-slate-400">
      {children}
    </div>
  );
}

function ElevenMenu() {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <button
        onClick={() => setOpen((v) => !v)}
        className={`${linkBase} w-full text-slate-700 hover:bg-slate-100 justify-between`}
      >
        <div className="flex items-center gap-3">
          <Zap className="h-4 w-4" />
          11.11
        </div>
        <ChevronDown
          className={`h-4 w-4 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="mt-1 ml-4 space-y-1 border-l border-slate-200 pl-3">
          <NavLink to="/eleven/categories" className={linkClass}>
            <Tags className="h-4 w-4" />
            Categories
          </NavLink>
          <NavLink to="/eleven/products" className={linkClass}>
            <Package className="h-4 w-4" />
            Products
          </NavLink>
          <NavLink to="/eleven/carts" className={linkClass}>
            <ShoppingCart className="h-4 w-4" />
            Carts
          </NavLink>
          <NavLink to="/eleven/payments" className={linkClass}>
            <DollarSign className="h-4 w-4" />
            Payments
          </NavLink>
          <NavLink to="/eleven/orders" className={linkClass}>
            <ShoppingBag className="h-4 w-4" />
            Orders
          </NavLink>
        </div>
      )}
    </div>
  );
}

function ShippingMenu() {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <button
        onClick={() => setOpen((v) => !v)}
        className={`${linkBase} w-full text-slate-700 hover:bg-slate-100 justify-between`}
      >
        <div className="flex items-center gap-3">
          <PlaneTakeoff className="h-4 w-4" />
          Shipping
        </div>
        <ChevronDown
          className={`h-4 w-4 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="mt-1 ml-4 space-y-1 border-l border-slate-200 pl-3">
          <NavLink to="/shipping/countries" className={linkClass}>
            <Globe className="h-4 w-4" />
            Countries
          </NavLink>
          <NavLink to="/shipping/warehouses" className={linkClass}>
            <Warehouse className="h-4 w-4" />
            Warehouses
          </NavLink>
          <NavLink to="/shipping/companies" className={linkClass}>
            <Building2 className="h-4 w-4" />
            Companies
          </NavLink>
          <NavLink to="/shipping/prices" className={linkClass}>
            <DollarSign className="h-4 w-4" />
            Prices
          </NavLink>
          <NavLink to="/shipping/categories" className={linkClass}>
            <Tag className="h-4 w-4" />
            Categories
          </NavLink>
        </div>
      )}
    </div>
  );
}

function CampaignMenu() {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <button
        onClick={() => setOpen((v) => !v)}
        className={`${linkBase} w-full text-slate-700 hover:bg-slate-100 justify-between`}
      >
        <div className="flex items-center gap-3">
          <Package className="h-4 w-4" />
          Campaigns
        </div>
        <ChevronDown
          className={`h-4 w-4 text-slate-400 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div className="mt-1 ml-4 space-y-1 border-l border-slate-200 pl-3">
          <NavLink to="/campaigns/all" className={linkClass}>
            <Globe className="h-4 w-4" />
            All Campaigns
          </NavLink>
          <NavLink to="/campaigns/segments" className={linkClass}>
            <Warehouse className="h-4 w-4" />
            Segments
          </NavLink>
          <NavLink to="/campaigns/categories" className={linkClass}>
            <Building2 className="h-4 w-4" />
            Categories
          </NavLink>
          <NavLink to="/campaigns/products" className={linkClass}>
            <DollarSign className="h-4 w-4" />
            Products
          </NavLink>
        </div>
      )}
    </div>
  );
}

export default function Sidebar() {
  return (
    <aside className="w-[290px] border-r bg-slate-50/60 p-5 rounded-l-2xl">
      {/* Brand */}
      <div className="flex items-center gap-3">
        <div className="h-9 w-9 rounded-xl bg-emerald-500 text-white flex items-center justify-center font-bold">
          A
        </div>
        <div>
          <div className="text-base font-semibold text-slate-900">
            Ali Store BD
          </div>
          <div className="text-xs text-slate-500">Admin Panel</div>
        </div>
      </div>

      {/* Search */}
      <div className="mt-5 flex items-center gap-2 rounded-xl bg-white px-3 py-2 ring-1 ring-slate-200">
        <Search className="h-4 w-4 text-slate-400" />
        <input
          className="w-full bg-transparent text-sm outline-none placeholder:text-slate-400"
          placeholder="Search..."
        />
      </div>

      <SectionLabel>MAIN MENU</SectionLabel>

      <nav className="mt-2 space-y-1">
        <NavLink to="/dashboard" className={linkClass}>
          <LayoutDashboard className="h-4 w-4" />
          Dashboard
        </NavLink>

        <NavLink to="/orders" className={linkClass}>
          <ShoppingBag className="h-4 w-4" />
          Orders
        </NavLink>

        <NavLink to="/shipments" className={linkClass}>
          <Package className="h-4 w-4" />
          Shipments
        </NavLink>

        <NavLink to="/delivery-requests" className={linkClass}>
          <Truck className="h-4 w-4" />
          Delivery Requests
        </NavLink>

        <NavLink to="/categories" className={linkClass}>
          <Tags className="h-4 w-4" />
          Categories
        </NavLink>

        <NavLink to="/Payments" className={linkClass}>
          <DollarSign className="h-4 w-4" />
          Payments
        </NavLink>

        <NavLink to="/discounts" className={linkClass}>
          <Ticket className="h-4 w-4" />
          Discounts
        </NavLink>

        <NavLink to="/customers" className={linkClass}>
          <Users className="h-4 w-4" />
          Customers
        </NavLink>

        <NavLink to="/analytics" className={linkClass}>
          <LineChart className="h-4 w-4" />
          Analytics
        </NavLink>

        <NavLink to="/team" className={linkClass}>
          <UsersRound className="h-4 w-4" />
          Team
        </NavLink>

        <ElevenMenu />

        <ShippingMenu />

        <CampaignMenu />
      </nav>

      <SectionLabel>OTHER</SectionLabel>

      <div className="mt-2 space-y-1">
        <button
          className={`${linkBase} w-full text-slate-700 hover:bg-slate-100`}
        >
          <HelpCircle className="h-4 w-4" />
          Help Center
        </button>
        <button
          className={`${linkBase} w-full text-slate-700 hover:bg-slate-100`}
        >
          <Settings className="h-4 w-4" />
          Settings
        </button>
        <NavLink to="/logs" className={linkClass}>
          <ClipboardList className="h-4 w-4" />
          Activity Logs
        </NavLink>
        <button
          className={`${linkBase} w-full text-slate-700 hover:bg-slate-100`}
        >
          <Zap className="h-4 w-4" />
          Automation
        </button>
        <button
          className={`${linkBase} w-full text-slate-700 hover:bg-slate-100`}
        >
          <Plug className="h-4 w-4" />
          Integration
        </button>
        <button
          className={`${linkBase} w-full text-slate-700 hover:bg-slate-100`}
        >
          <Headphones className="h-4 w-4" />
          AI-Support
        </button>
      </div>

      {/* user card bottom */}
      <SidebarUserMenu />
    </aside>
  );
}
